import { render, staticRenderFns } from "./newCoupons.vue?vue&type=template&id=3b614cdf&"
import script from "./newCoupons.vue?vue&type=script&lang=js&"
export * from "./newCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports